import React from "react";
import { Pressable, Text } from "react-native";

interface Props {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export default function ButtonBottomBorder(props: Props) {
  return (
    <Pressable disabled={props.disabled} onPress={() => props.onClick()}>
      <Text
        className={`text-base font-light ${
          props.isSelected ? "border-b-2 border-purple1 text-purple1" : ""
        }`}
      >
        {props.label}
      </Text>
    </Pressable>
  );
}
